import styled from "styled-components";
import {
  color_black_light,
  color_grey_light,
  color_grey_ultra_light,
  color_white,
} from "../constants/colors";
import { useI18n } from "./I18nProvider";

const Switcher = styled.div`
  display: inline-grid;
  grid-template-columns: repeat(2, 1fr);
  width: ${(props) => (props.$compact ? "108px" : "126px")};
  height: ${(props) => (props.$compact ? "38px" : "44px")};
  padding: 3px;
  box-sizing: border-box;
  border: 1px solid ${color_grey_light};
  border-radius: 14px;
  background: ${color_grey_ultra_light};

  @media (max-width: 380px) {
    width: ${(props) => (props.$compact ? "88px" : "108px")};
    height: ${(props) => (props.$compact ? "36px" : "40px")};
  }
`;

const LanguageButton = styled.button`
  min-width: 0;
  border: 0;
  border-radius: 10px;
  background: ${(props) => (props.$active ? color_white : "transparent")};
  color: ${(props) =>
    props.$active ? color_black_light : "rgba(43, 43, 43, 0.64)"};
  font: ${(props) =>
    props.$active
      ? "600 16px/1 Onest, sans-serif"
      : "400 16px/1 Onest, sans-serif"};
  cursor: pointer;
  transition:
    background-color 160ms ease,
    color 160ms ease;

  &:focus-visible {
    outline: 2px solid rgba(240, 79, 79, 0.32);
    outline-offset: 1px;
  }
`;

const LanguageSwitcher = ({ compact = false, className, ariaLabel }) => {
  const { locale, setLocale, t } = useI18n();

  return (
    <Switcher
      $compact={compact}
      className={className}
      role="group"
      aria-label={ariaLabel || t("Язык интерфейса")}
    >
      {["ru", "en"].map((language) => (
        <LanguageButton
          key={language}
          type="button"
          $active={locale === language}
          aria-pressed={locale === language}
          onClick={() => setLocale(language)}
        >
          {language.toUpperCase()}
        </LanguageButton>
      ))}
    </Switcher>
  );
};

export default LanguageSwitcher;
